import { Vue, Component, Prop, Emit } from "vue-property-decorator";

@Component({
    name: "AiAvatar"
})
export default class AiAvatar extends Vue {
    @Prop() readonly item: any;
}
//@ts-ignore
export { default as AiAvatar } from "./index.vue";
